import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
    IEarmoldSelection,
    IOrderDetails,
} from '../../../models/product-detail';
import ToolTipAnchor from '../../common/tooltip';
import SelectInput from '../../inputs/select-input';
import { ProductOrderFormErrors } from './validation';
import { WrappedComponentProps, injectIntl } from 'react-intl';
interface IEarmoldStyleSelectionProps {
    earmoldsTypes: IEarmoldSelection[];
    onChange: (name: string, value?: number) => void;
    orderState: IOrderDetails;
    noteHtml?: string;
    errors: ProductOrderFormErrors;
}

const EarmoldStyleSelection = ({
    earmoldsTypes,
    onChange,
    orderState,
    noteHtml,
    errors,
}: IEarmoldStyleSelectionProps) => {
    const [substyleOptions, setSubstyleOptions] = useState<
        IEarmoldSelection[] | null
    >();

    const [selectedStyle, setSelectedStyle] = useState<string | undefined>();
    const [selectedSubStyle, setSelectedSubstyle] = useState<
        string | undefined
    >();

    const updateStyle = (e: React.ChangeEvent<any>) => {
        const { name, value } = e.target;

        if (name === 'EarmoldStyleSelection') {
            const style = earmoldsTypes.find((x) => x.key === value);
            if (style) {
                if (style && !style.items) {
                    setSelectedStyle(style.key);
                    setSelectedSubstyle(undefined);
                    setSubstyleOptions(null);
                    onChange('earmoldDesignId', style.designId);
                }

                if (style && style.items) {
                    setSelectedStyle(e.target.value);
                    setSubstyleOptions(style.items);
                    onChange('earmoldDesignId', undefined);
                }
            } else {
                setSelectedStyle(undefined);
                setSelectedSubstyle(undefined);
                setSubstyleOptions(null);
                onChange('earmoldDesignId', undefined);
            }
        }

        if (name === 'EarmoldSubStyleSelection') {
            if (substyleOptions) {
                const subStyle = substyleOptions.find((x) => x.key === value);
                if (!subStyle) {
                    setSelectedSubstyle(undefined);
                    onChange('earmoldDesignId', undefined);
                } else {
                    setSelectedSubstyle(subStyle.key);
                    onChange('earmoldDesignId', subStyle.designId);
                }
            }
        }
    };

    useEffect(() => {
        let style: IEarmoldSelection | undefined;
        if (orderState.earmoldDesignId) {
            style = earmoldsTypes.find(
                (x) => x.designId === orderState.earmoldDesignId
            );
            if (style) {
                setSelectedStyle(style.key);
            }
            if (!style) {
                style = earmoldsTypes.find((x) => {
                    return (
                        x.items &&
                        x.items.some((y) => {
                            return y.designId === orderState.earmoldDesignId;
                        })
                    );
                });

                if (style) {
                    setSubstyleOptions(style!.items);
                    const subStyle = style.items.find(
                        (x) => x.designId === orderState.earmoldDesignId
                    );
                    if (subStyle) {
                        setSelectedStyle(style!.key);
                        setSelectedSubstyle(subStyle.key);
                    }
                }
            }
        }

        if (earmoldsTypes.length === 1 && !style) {
            setSelectedStyle(earmoldsTypes[0].key);
            setSubstyleOptions(earmoldsTypes[0].items);
        }
    }, [orderState]);

    return (
        <>
            {earmoldsTypes && (
                <>
                    {earmoldsTypes.length === 1 ? (
                        <div className="row">
                            <div className="col-sm-4">
                                <div className="col-sm-12">
                                    <label>
                                        <FormattedMessage
                                            id="Type"
                                            defaultMessage="Type"
                                        />
                                        :
                                    </label>
                                </div>
                                <div className="col-sm-12">
                                    <label>{earmoldsTypes[0].name}</label>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-sm-4">
                                <SelectInput
                                    name="EarmoldStyleSelection"
                                    label="Style"
                                    options={earmoldsTypes.map((x) => ({
                                        value: x.key,
                                        text: x.name,
                                    }))}
                                    value={selectedStyle}
                                    hasDefaultOption={true}
                                    defaultOption={'Select'}
                                    required={true}
                                    fieldClassName={'col-sm-12'}
                                    labelClassName={'col-sm-12'}
                                    onChange={updateStyle}
                                    customLabel={true}
                                    error={errors.earmoldDesignId}
                                />
                            </div>
                            {noteHtml && (
                                <ToolTipAnchor toolTipMessage={noteHtml!} />
                            )}
                        </div>
                    )}
                    {substyleOptions && (
                        <>
                            <div className="row">
                                <div className="col-sm-4">
                                    <SelectInput
                                        name="EarmoldSubStyleSelection"
                                        label="Sub-Style"
                                        options={substyleOptions.map((x) => ({
                                            value: x.key,
                                            text: x.name,
                                        }))}
                                        value={selectedSubStyle}
                                        hasDefaultOption={true}
                                        defaultOption={'Select'}
                                        required={true}
                                        fieldClassName={'col-sm-12'}
                                        labelClassName={'col-sm-12'}
                                        onChange={updateStyle}
                                        customLabel={true}
                                        error={errors.earmoldDesignId}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default EarmoldStyleSelection;
